/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-undef */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable no-useless-escape */
/* eslint-disable unicorn/better-regex */
/* eslint-disable prettier/prettier */
import formValidation from 'formvalidation/core/Core';
import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';
import SelectorEngine from '../../utils/dom/selector-engine';
import dataLayer from '../../utils/data-layer';

import Request from '../../utils/request';
import SnackbarNotification from '../../components/SnackbarNotification';
// eslint-disable-next-line no-unused-vars
import { scrollToElement, scrollToTop, scrollToNode, getDataFromForm } from '../../utils/misc';

import ValidationUtils from '../../utils/validation';
import Manipulator from '../../utils/dom/manipulator';

class CreateAccount {
	constructor() {
		this._accountWrapper = undefined;
		this._emailWrapper = undefined;
		//Scala Integration: By default we are setting the value as false as we will need to update it to true only after reading the alert updated by user.
		this.ltlAgeValidationAlertRead = false;
		this.initiateValidation();
	}

	initiateValidation() {
		this._accountWrapper = document.querySelector('.lta-account-registration');
		this._emailWrapper = document.querySelector('.p-email-confirmation');
		if (this._accountWrapper && this._emailWrapper) {
			const registerAccountForm = this._accountWrapper.querySelector('#accountRegister');
			const errorWrapper = this._accountWrapper.querySelector('.lta-account-registartion--error');
			const errorDefault = this._accountWrapper.querySelector('.lta-account-registartion--error-default');
			const errorLtlAgeValidation = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation');
			const errorTitleLTLAgeValidationis = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation').getAttribute('data-title') || '';
			const errorMessageLTLAgeValidation = this._accountWrapper.querySelector('.lta-account-registartion--error-ltl-age-validation').getAttribute('data-error-message') || '';
			const emailErrorWrapper = this._emailWrapper.querySelector('.p-email-confirmation--error');
			const dateComponent = SelectorEngine.findOne('#dob', this._accountWrapper);
			this.strictMinAge = Manipulator.getDataAttribute(dateComponent, 'strictMinAge') || 4;
			this.minAge = Manipulator.getDataAttribute(dateComponent, 'minAge');
			this.minAgeErrorMessage = Manipulator.getDataAttribute(dateComponent, 'minAgeErrorMessage');
			this.ageStrictCheck = Manipulator.getDataAttribute(dateComponent, 'strictCheck');
			const errorFieldsContainer = this._accountWrapper.querySelector('.lta-account-registartion--fields-error');
			const emailAction = this._emailWrapper.querySelector('.js-resend-email');
			const resendEmailNotificationWrapper = SelectorEngine.findOne('.js-notification', this._emailWrapper);
			const captchaEnabled = SelectorEngine.findOne('#google_recaptcha')
			
			this.registerAccountForm = registerAccountForm;
			this.errorWrapper = errorWrapper;
			this.errorDefault = errorDefault;
			this.errorLtlAgeValidation = errorLtlAgeValidation;
			this.emailResendBtn = emailAction;
			this.emailErrorWrapper = emailErrorWrapper;
			this.resendEmailNotificationWrapper = resendEmailNotificationWrapper;

			this.formSubmitBtn = this.registerAccountForm.querySelector('.js-create-submit');

			const resendEmailNotification = new SnackbarNotification(resendEmailNotificationWrapper, {});

			const errorDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error');
			errorDismissCta.addEventListener('click', () => {
				errorWrapper.classList.add('u-hidden');
			});

			const errorDefaultDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error-default');
			errorDefaultDismissCta.addEventListener('click', () => {
				this.formSubmitBtn.disabled = false;
				errorDefault.classList.add('u-hidden');
			});

			const errorltlAgeValidationDismissCta = this._accountWrapper.querySelector('.js-dismiss-account-error-ltl-age-validation');
			errorltlAgeValidationDismissCta.addEventListener('click', () => {
				errorLtlAgeValidation.classList.add('u-hidden');
				this.ltlAgeValidationAlertRead = true;
				registerAccountForm.querySelector('.js-create-submit').click();
			});


			const errorEmailDismissCta = emailErrorWrapper.querySelector('.js-dismiss-email-error');
			errorEmailDismissCta.addEventListener('click', () => {
				emailErrorWrapper.classList.add('u-hidden');
				emailAction.disabled = false;
			});

			const errorFieldsWrapper = errorFieldsContainer.querySelector('.lta-account-registartion--fields-container');
			const fieldsErrorsList = errorFieldsWrapper.querySelector('ul');
			fieldsErrorsList.textContent = '';

			if (registerAccountForm !== null) {
				const fv = formValidation(registerAccountForm, {
					fields: {
						firstName: {
							validators: {
								notEmpty: {
									message: 'Please enter a first name'
								},
								stringLength: {
									min: 2,
									message: 'First Name must be 2 or more characters'
								},
								regexp: {
									regexp: /^[a-zA-Z-' ]+$/,
									message: 'Please enter a firstname that contains only characters'
								}
							}
						},
						lastName: {
							validators: {
								notEmpty: {
									message: 'Please enter a last name'
								},
								stringLength: {
									min: 2,
									message: 'Last Name must be 2 or more characters'
								},
								regexp: {
									regexp: /^[a-zA-Z-' ]+$/,
									message: 'Please enter lastname that contains only characters'
								}
							}
						},
						dob: {
							validators: {
								splitDate: {
									missingMessage: 'Please enter a date of birth',
									invalidMessage: 'Please enter a valid date',
									futureMessage: 'Please enter a date in the past',
									message: `Members need to be over ${this.strictMinAge} years of age`,
									maxAge: this.strictMinAge,
									invalidDate: 'Please enter a valid date'
								}
							}
						},
						gender: {
							validators: {
								radioSelected: {
									message: 'Please choose a gender'
								}
							}
						},
						emailAddress: {
							validators: {
								notEmpty: {
									message: 'Please enter an email address'
								},
								regexp: {
									regexp:
										/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
									message: 'Please enter a valid email address'
								}
							}
						},
						username: {
							validators: {
								notEmpty: {
									message: 'Please enter a username'
								},
								stringLength: {
									min: 6,
									max: 19,
									message: 'Please choose a username that is longer than 6 and fewer than 19 characters'
								},
								regexp: {
									regexp: /^[\w\d_.-]+$/,
									message: 'Please choose a username that contains just letters and numbers'
								},
								different: {
									compare: () => '',
									message: 'This username has already been taken. Please choose another username'
								}
							}
						},
						password: {
							validators: {
								notEmpty: {
									message: 'Please enter a password'
								},
								stringLength: {
									min: 8,
									max: 19,
									message: 'Please choose a password that is longer than 8 and fewer than 19 characters'
								},
								regexp: {
									regexp: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-.\\\/:;<=>?@[\]^_`{|}~])/g,
									message: 'Please enter at least one upper and lower case character, a number and a special character'
								},
								different: {
									compare: () => registerAccountForm.querySelector('[name="username"]').value,
									message: 'Please create a password that is different to your username'
								}
							}
						}
					},
					plugins: {
						trigger: new Trigger(),
						submitButton: new SubmitButton(),
						message: new Message({
							clazz: 'lta-text-input__label-instruction',
							container: function (field, element) {
								const fieldType = element.getAttribute('type');
								const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
								return inputWrapper.querySelector('.lta-text-input--error');
							}
						})
					}
				})
					.on('core.field.invalid', (name) => {
						const invalidField = document.getElementsByName(name)[0];
						const invalidFieldType = invalidField.getAttribute('type');
						const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
						fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
					})
					.on('core.field.valid', (name) => {
						const invalidField = document.getElementsByName(name)[0];
						const invalidFieldType = invalidField.getAttribute('type');
						const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
						fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(invalidFieldType));

						// remove error messages that are now valid
						const errorMessages = SelectorEngine.find(`.js-validation-${name}`, fieldsErrorsList);
						if (errorMessages) {
							[...errorMessages].forEach((element) => {
								element.remove();
							});
						}

						// if there are no more error messages, remove error messages container
						if (fieldsErrorsList.children.length === 0) {
							errorFieldsContainer.classList.add('u-hidden');
						}
					})
					.on('core.form.invalid', () => {
						errorFieldsContainer.classList.remove('u-hidden');
						errorFieldsContainer.scrollIntoView();
					})
					.on('core.form.validating', () => {
						fieldsErrorsList.textContent = '';
					})
					.on('plugins.message.displayed', (e) => {
						// checks if error message isn't already added
						if (!SelectorEngine.findOne(`.js-validation-${e.field}--${e.validator}`, fieldsErrorsList)) {
							const listItem = document.createElement('li');
							const listSpan = document.createElement('span');
							const listLink = document.createElement('a');
							listLink.setAttribute('href', '#');
							listItem.setAttribute('class', `js-validation-${e.field} js-validation-${e.field}--${e.validator}`);
							listLink.append(document.createTextNode(e.message));
							listSpan.append(listLink);
							listItem.append(listSpan);

							fieldsErrorsList.append(listItem);

							listLink.addEventListener('click', (event) => {
								event.preventDefault();
								scrollToNode(e.element);
								e.element.focus();
							});
						}
					})
					.on('core.form.valid', () => {
						errorFieldsContainer.classList.add('u-hidden');
						this.formSubmitBtn.disabled = true;

						let isGoogleCaptchaValid = this.getCaptchaResponse();
						const queryString = window.location.search;
						const urlParameters = new URLSearchParams(queryString);
						// Scala App Integration : As the Signup Button is called again post LTL Age Valitdation alert is provided and bypassed to proceed ahead. So Google captcha is disabled here.
						if (urlParameters.has('source') && urlParameters.get('source') === "ltl") {
							if (this.ltlAgeValidationAlertRead) {
								isGoogleCaptchaValid = true;
							}
						}

						if (isGoogleCaptchaValid) {
							const finalData = this.preparePayload();
							const [dd, mm, yy] = finalData.dob.split('/');

							// Scala App Integration : this variable is handled for validating date when Signup is being triggered from external Scala app and query parameter source = ltl has added.
							let isDateValidated = true;

							const dob = new Date(`${mm}/${dd}/${yy}`);
							const currentDate = new Date();

							const age = currentDate.getFullYear() - dob.getFullYear();
							if (age < this.minAge && !this.ltlAgeValidationAlertRead) {
								isDateValidated = false;
								const errorList = errorLtlAgeValidation.querySelector('ul');
								errorList.textContent = this.minAgeErrorMessage;
								errorLtlAgeValidation.classList.remove('u-hidden');
								errorLtlAgeValidation.scrollIntoView();
								this.formSubmitBtn.disabled = false;
							} else {
								this.ltlAgeValidationAlertRead = true;
							}
							if (isDateValidated && this.ltlAgeValidationAlertRead) {
								this.registerUser(finalData);
							} 
						} else {
							console.log({isGoogleCaptchaValid})
							this.invalidCaptcha();
						}
					})
				}
		}
	}

	preparePayload() {
		const urlParameters = new URLSearchParams(window.location.search);
		const dataObject = getDataFromForm(this.registerAccountForm);
		const dobBits = dataObject.dob.split('-');
		const newDataObject = {
			...dataObject,
			dob: `${dobBits[2]}/${dobBits[1]}/${dobBits[0]}`,
			marketingConsent: dataObject.marketingConsent || 'No',
			offerConsent: dataObject.offerConsent || 'No',
			termsAndConditionConsent: 'Yes',
			returnUrl: urlParameters.get('redirect_uri')
		};
		return newDataObject;
	}

	async registerUser(data) {
		let response;
		try {
			const apiResponse = await Request.post(this.registerAccountForm.dataset.url, data);
			this.resetCaptcha();
			this.formSubmitBtn.disabled = false;
			if (!apiResponse.Success) {
				response = apiResponse.AccountRegistryResponse.response;
				if (response === 'Username exists' || response === 'ACCOUNT_ALREADY_EXISTS') {
					fv.updateValidatorOption('username', 'different', 'compare', () => finalData.username).updateFieldStatus('username', 'Invalid', 'different');
					scrollToElement('[name="emailAddress"]');
				} else {
					this.showRegistrationError(response);
				}
				this.ltlAgeValidationAlertRead = false;
			} else {
				const registerForm = document.querySelector('.lta-account-registration');
				const emailConfirm = document.querySelector('.p-email-confirmation');
				registerForm.classList.add('u-hidden');
				emailConfirm.classList.remove('u-hidden');
				emailConfirm.scrollIntoView();
				this.ltlAgeValidationAlertRead = false;
				try { // Pushing event  to datalayer for tracking
					dataLayer.push({
						event: 'new membership not-verified',
					});
				} catch (error) {
					console.log(error.message);
				}
			}	
			this.emailResendBtn.addEventListener('click', () => {
				this.resendEmailHandler();
			});
		} catch(error) {
			console.error(error);
			
			const errorListItem = SelectorEngine.findOne('ul li span', this.errorDefault);
			let errorMessage = 'Please try again in 10 minutes.';
			
			// Handle different types of network errors
			if (error.name === 'TypeError') {
				if (error.message && error.message.toLowerCase().includes('failed to fetch')) {
					errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
				} else if (error.message && error.message.toLowerCase().includes('network')) {
					errorMessage = 'Network error occurred. Please check your internet connection and try again.';
				} else {
					errorMessage = 'Request timed out. Please check your internet connection and try again.';
				}
			} else if (error.name === 'AbortError') {
				errorMessage = 'Request was cancelled. Please try again.';
			} else if (error.message) {
				// Check for specific error messages
				if (error.message.toLowerCase().includes('timeout')) {
					errorMessage = 'Request timed out. Please try again.';
				} else if (error.message.toLowerCase().includes('network')) {
					errorMessage = 'Network error occurred. Please check your internet connection and try again.';
				} else if (error.message.toLowerCase().includes('fetch')) {
					errorMessage = 'Failed to connect to the server. Please try again.';
				} else {
					errorMessage = error.message;
				}
			}
			
			errorListItem.innerHTML = errorMessage;
			
			this.errorDefault.classList.remove('u-hidden');
			this.errorDefault.scrollIntoView();
		}
		return response;
	}

	async resendEmailHandler() {
		const usernameValue = this.registerAccountForm.querySelector('[name="username"]').value;
		this.emailResendBtn.disabled = true;

		const resendEmail = await Request.post('/api/AccountRegisterApi/ResendEmailVerification', { username: usernameValue })
			.catch((error) => {
				console.error('Resend email error:', error);
				
				// Update error message based on the type of error
				const emailErrorMessage = this.emailErrorWrapper.querySelector('.title');
				const emailErrorList = this.emailErrorWrapper.querySelector('ul li span');
				
				if (emailErrorMessage && emailErrorList) {
					let errorMessage = 'Failed to resend verification email. Please try again.';
					
					if (error.name === 'TypeError' && error.message && error.message.toLowerCase().includes('failed to fetch')) {
						errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
					} else if (error.message && error.message.toLowerCase().includes('network')) {
						errorMessage = 'Network error occurred. Please check your internet connection and try again.';
					} else if (error.message && error.message.toLowerCase().includes('timeout')) {
						errorMessage = 'Request timed out. Please try again.';
					}
					
					emailErrorList.innerHTML = errorMessage;
				}
				
				this.emailErrorWrapper.classList.remove('u-hidden');
				this.emailErrorWrapper.scrollIntoView();
			});

		if (resendEmail?.Success) {
			this.resendEmailNotificationWrapper.open();
			this.emailResendBtn.disabled = false;
		} else {
			this.emailErrorWrapper.classList.remove('u-hidden');
			this.emailErrorWrapper.scrollIntoView();
		}
	}

	showRegistrationError(response) {
		const errorMessage = this.errorDefault.querySelector('.title');
		const errorList = this.errorDefault.querySelector('ul');

		const responseParts = response?.split(/\n/).filter(item => !!item) || [];
		const errorTitle = responseParts.shift();
		errorMessage.innerHTML = errorTitle;
		errorList.textContent = '';
		
		if (responseParts.length > 0) {
			responseParts.forEach((part) => {
				const liElement = document.createElement('li');
				const spanElement = document.createElement('span');
				spanElement.textContent = part;
				liElement.append(spanElement);
				errorList.append(liElement);
			})
		}
		
		this.errorDefault.classList.remove('u-hidden');
		this.errorDefault.scrollIntoView();
	}

	invalidCaptcha() {
		const errorList = this.errorDefault.querySelector('ul');
		errorList.textContent = 'Captcha is invalid. Please validate.';
		this.errorDefault.classList.remove('u-hidden');
		this.errorDefault.scrollIntoView();
		this.formSubmitBtn.disabled = false;
		this.ltlAgeValidationAlertRead = false;
	}

	resetCaptcha() {
		if(SelectorEngine.findOne('#google_recaptcha')) {
			grecaptcha.reset();
		}
	}

	getCaptchaResponse() {
		let isValid = false;
		if (SelectorEngine.findOne('#google_recaptcha')) {
			try {
				const captchaResponse = grecaptcha?.getResponse();
				if (captchaResponse.length > 0) {
					isValid = true;
				} else {
					isValid = false;
				}
			} catch (error) {
				isValid = true;
				console.error(error);
			}
		} else {
			isValid = true;
		}
		return isValid;
	}
}

const globalCreateAccount = new CreateAccount();

export default globalCreateAccount;
